import { useEffect, useState, useRef } from 'react'
import styles from './index.module.scss'
interface Props {
  itemsNode: any
}
const WaterLayout: React.FC<Props> = ({ itemsNode }) => {
  const [waterHeight, setWaterHeight] = useState<number[]>([])
  const $wrapRef = useRef(null)
  const gap = 0

  const waterFall = () => {
    if ($wrapRef.current) {
      try {
        const $wrap = $wrapRef.current
        const $items = $wrap.children
        const $itemWidth =
          $wrap.querySelector(`.${styles['water-item']}`)?.clientWidth || 0
        const columns = Math.floor($wrap.clientWidth / $itemWidth) // 一行多少列
        let newHeightArr = []
        let boxOffsetTopArr = []
        for (let i = 0; i < $items.length; i++) {
          if (i < columns) {
            $items[i].style.top = 0 + 'px'
            $items[i].style.height = $items[i].offsetHeight + 'px'
            $items[i].style.left = i * ($itemWidth + gap) + 'px'
            newHeightArr[i] = $items[i].offsetHeight
            boxOffsetTopArr.push({
              top: 0,
              height: $items[i].offsetHeight
            })
          } else {
            //取出最小高度
            const minHeight = Math.min(...newHeightArr)
            //记录最小高度的索引值
            const minIndex = newHeightArr.indexOf(minHeight)
            $items[i].style.top = minHeight + gap + 'px'
            $items[i].style.left = $items[minIndex]?.offsetLeft + 'px'
            $items[i].style.height = $items[i].offsetHeight + 'px'
            //更新原最小高度
            newHeightArr[minIndex] += gap + $items[i].offsetHeight
            boxOffsetTopArr.push({
              top: minHeight + gap,
              height: $items[i].offsetHeight
            })
          }
        }

        const maxItem = boxOffsetTopArr?.reduce((acc, curr) => {
          const currSum = curr.top + curr.height
          const maxSum = acc.top + acc.height
          return currSum > maxSum ? curr : acc
        })

        let maxHeightSum = maxItem.top + maxItem.height

        // for (const item of boxOffsetTopArr) {
        //   if (item.top > maxTopItem.top) {
        //     maxTopItem = item
        //     maxHeightSum = item.top + item.height
        //   }
        // }

        // if (boxOffsetTopArr.length <= columns) {
        //   const maxHeightItem = boxOffsetTopArr.reduce(
        //     (maxItem, currentItem) => {
        //       return currentItem.height > maxItem.height ? currentItem : maxItem
        //     },
        //     boxOffsetTopArr[0]
        //   )
        //   maxHeightSum = maxHeightItem.height
        // }

        // 计算最大top对应的height的和
        setWaterHeight(maxHeightSum)
      } catch (err) {}
    }
  }

  useEffect(() => {
    waterFall()
  }, [])

  return (
    <div
      className={`${styles['water-container']}`}
      style={{ height: `${waterHeight}px` }}
      ref={$wrapRef}>
      {itemsNode}
    </div>
  )
}

export default WaterLayout
